import { ChangeDetectionStrategy, Component, Signal, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

/** Which action the sheet was dismissed with — `undefined` means Cancel/backdrop dismiss. */
export type GroceryRowAction = "refresh" | "archive" | "remove";

export interface GroceryRowActionsSheetData {
  itemName: string;
  /** Formatted price chip text (e.g. "2.40 AUD"), or null for an item with no price yet. */
  priceLabel: string | null;
  /** Custom/unlisted items have no store link to refresh, so that action is hidden. */
  showRefresh: boolean;
  /** True while this row's price refresh is in flight (single or bulk) — disables Refresh so a tap isn't silently ignored. */
  refreshing: Signal<boolean>;
}

/** Mobile-only bottom sheet for a grocery list row's actions (Refresh price / Archive this item / Remove from list). */
@Component({
  selector: "app-grocery-row-actions-sheet",
  templateUrl: "./grocery-row-actions-sheet.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroceryRowActionsSheetComponent {
  private readonly dialogRef =
    inject<MatDialogRef<GroceryRowActionsSheetComponent, GroceryRowAction | undefined>>(
      MatDialogRef,
    );
  protected readonly data = inject<GroceryRowActionsSheetData>(MAT_DIALOG_DATA);

  protected choose(action: GroceryRowAction): void {
    this.dialogRef.close(action);
  }

  protected cancel(): void {
    this.dialogRef.close();
  }
}
